import React from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Theme, useTheme, Typography, SxProps } from '@mui/material'
import { BoxProps } from '@mui/system'

export const sharedButtonStyles = ({
  theme,
}: {
  theme: Theme
}): SxProps<Theme> => ({
  margin: theme.spacing(0, 1),
  [theme.breakpoints.down('sm')]: {
    marginX: 'auto',
  },
  color: 'white',
  textDecoration: 'none',
  backgroundColor: '#57ab82',
  padding: theme.spacing(1, 2),
  boxShadow:
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
  borderRadius: theme.spacing(0.5),
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: '#499c72',
    textDecoration: 'none',
  },
})

interface ShowFullScreenButtonProps {
  assetKey: number
  academicYear?: string
  buttonContainerStyles?: SxProps<Theme>
}

const ShowFullScreenButton: React.FC<ShowFullScreenButtonProps> = ({
  assetKey,
  academicYear,
  buttonContainerStyles,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const ShowFullScreenNavLink: React.FC<BoxProps & NavLinkProps> = (props) => (
    <Box component={NavLink} sx={sharedButtonStyles({ theme })} {...props} />
  )

  return (
    <Box display="flex" justifyContent="flex-end" sx={buttonContainerStyles}>
      <ShowFullScreenNavLink
        to={{
          pathname: `/content/asset/fullScreen/${assetKey}${
            academicYear ? `/${academicYear}` : ''
          }`,
        }}
        target="_blank"
      >
        <Typography fontWeight="bold" fontFamily="sweet-sans-pro, sans-serif">
          {t(
            'ShowFullScreenButton.Label.LaunchFullscreen',
            'Launch Fullscreen'
          )}
        </Typography>
      </ShowFullScreenNavLink>
    </Box>
  )
}
export default ShowFullScreenButton
